export { AppStatus, Tier, Role, ToolKind, SsoProvider, DownstreamAuthMethod, ConnectionState, TestStatus, TestKind, Visibility, AuditAction, HealthGroup, TestScheduleCadence } from '@mcper/core';

/** Routes of the history router (clean URLs; nginx and Vite fall back to index.html). */
export enum Route {
  Login = '/login',
  /** Not under /auth: nginx and the Vite dev server proxy that prefix to the server. */
  AuthCallback = '/signed-in',
  Apps = '/',
  /** Kept for old links; sends people to My agents. */
  Connect = '/connect',
  /** Public guide for one connector: every agent, one section each. */
  ConnectorGuide = '/guide/:key',
  MyAgents = '/my-agents',
  Connectors = '/connectors',
  ConnectorNew = '/connectors/new',
  ConnectorEdit = '/connectors/:id',
  /** Opened by an agent during OAuth: the person signs in, sees the offer and allows tools. */
  Authorize = '/authorize',
  AttachApp = '/apps/new',
  EditApp = '/apps/:slug/edit',
  AppDetail = '/apps/:slug',
  Tests = '/tests',
  TestsRuns = '/tests/runs',
  TestApp = '/tests/:slug',
  /** MCPer.io settings: sign-in, portal access, roles, safety, AI operator. Admins only; /org still redirects here. */
  Settings = '/settings',
  Org = '/org',
  Audit = '/audit',
}

/** Steps of the connect-app wizard, in order. */
export enum WizardStep {
  Basics = 0,
  AccessMethod = 1,
  SignIn = 2,
  Tools = 3,
  Presets = 4,
  Publish = 5,
}

/** Apps overview list mode. */
export enum AppsViewMode {
  Cards = 'cards',
  Table = 'table',
}

/** Apps overview filter chips. */
export enum AppsFilter {
  All = 'all',
  Live = 'live',
  Attention = 'attention',
  InProgress = 'in_progress',
  Browser = 'browser',
}

export enum ToastSeverity {
  Success = 'success',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}
